import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="rar" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#7e147e"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#4b124b"
          />
          <path
            id="Контур_824"
            data-name="Контур 824"
            d="M1.809-1.678H1.287V-.266H.322v-4H1.9a1.756,1.756,0,0,1,1.113.316,1.071,1.071,0,0,1,.4.893,1.3,1.3,0,0,1-.169.692,1.2,1.2,0,0,1-.529.445L3.548-.307v.041H2.515Zm-.522-.745H1.9a.548.548,0,0,0,.413-.144.557.557,0,0,0,.139-.4.563.563,0,0,0-.14-.405A.543.543,0,0,0,1.9-3.521h-.61ZM6.433-1.013H5.112l-.231.747H3.851l1.467-4h.907l1.478,4H6.667ZM5.343-1.757H6.2L5.771-3.145Zm4.306.08H9.127V-.266H8.163v-4H9.737a1.756,1.756,0,0,1,1.113.316,1.071,1.071,0,0,1,.4.893,1.3,1.3,0,0,1-.169.692,1.2,1.2,0,0,1-.529.445l.835,1.613v.041H10.355Zm-.522-.745h.61a.548.548,0,0,0,.413-.144.557.557,0,0,0,.139-.4.563.563,0,0,0-.14-.405.543.543,0,0,0-.412-.147h-.61Z"
            transform="translate(3 17)"
            fill="#fff"
          />
        </g>
        <g id="zip-2" transform="translate(569 298)">
          <g
            id="Сгруппировать_4114"
            data-name="Сгруппировать 4114"
            transform="translate(2 2)"
          >
            <g
              id="Сгруппировать_4113"
              data-name="Сгруппировать 4113"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_855"
                data-name="Прямоугольник 855"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4116"
            data-name="Сгруппировать 4116"
            transform="translate(0 0)"
          >
            <g
              id="Сгруппировать_4115"
              data-name="Сгруппировать 4115"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_856"
                data-name="Прямоугольник 856"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4118"
            data-name="Сгруппировать 4118"
            transform="translate(0 4)"
          >
            <g
              id="Сгруппировать_4117"
              data-name="Сгруппировать 4117"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_857"
                data-name="Прямоугольник 857"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4120"
            data-name="Сгруппировать 4120"
            transform="translate(2 6)"
          >
            <g
              id="Сгруппировать_4119"
              data-name="Сгруппировать 4119"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_858"
                data-name="Прямоугольник 858"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4122"
            data-name="Сгруппировать 4122"
            transform="translate(0 8)"
          >
            <g
              id="Сгруппировать_4121"
              data-name="Сгруппировать 4121"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_859"
                data-name="Прямоугольник 859"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
